import { render } from "./SiteDetail.vue?vue&type=template&id=0073e1ec"
import script from "./SiteDetail.vue?vue&type=script&lang=js"
export * from "./SiteDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__